module.exports = "<div class=\"cms-notification\" [innerHTML]=\"cmsNotification()\"></div>\n"